import { create } from 'zustand'
import {
  recordSseReconnectEnded,
  recordSseReconnectStarted,
} from '@/lib/sseReconnectTelemetry'

interface SseStatusState {
  streams: Record<string, boolean>
  setHealthy: (id: string, healthy: boolean) => void
  unregister: (id: string) => void
}

export const useSseStatusStore = create<SseStatusState>(set => ({
  streams: {},

  setHealthy: (id, healthy) =>
    set(state => {
      if (state.streams[id] === healthy) return state
      const streams = { ...state.streams, [id]: healthy }
      const wasUnhealthy = Object.values(state.streams).some(
        streamHealthy => streamHealthy === false
      )
      const isUnhealthy = Object.values(streams).some(
        streamHealthy => streamHealthy === false
      )

      if (!wasUnhealthy && isUnhealthy) {
        const unhealthyStreamIds = Object.entries(streams)
          .filter(([, streamHealthy]) => streamHealthy === false)
          .map(([streamId]) => streamId)
        recordSseReconnectStarted(unhealthyStreamIds)
      }

      if (wasUnhealthy && !isUnhealthy) {
        recordSseReconnectEnded()
      }

      return { streams }
    }),

  unregister: id =>
    set(state => {
      if (!(id in state.streams)) return state
      const wasUnhealthy = Object.values(state.streams).some(
        streamHealthy => streamHealthy === false
      )
      const next = { ...state.streams }
      delete next[id]

      const isUnhealthy = Object.values(next).some(
        streamHealthy => streamHealthy === false
      )
      if (wasUnhealthy && !isUnhealthy) {
        recordSseReconnectEnded()
      }

      return { streams: next }
    }),
}))

export const selectIsAnyUnhealthy = (state: SseStatusState): boolean =>
  Object.values(state.streams).some(healthy => healthy === false)
